import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit, Inject } from '@angular/core';
import { LovService } from './_service/lov.service';
import { MatTableDataSource, MatPaginator, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
declare var $: any;

@Component({
  selector: 'app-lov',
  templateUrl: './lov.component.html',
  styleUrls: ['./lov.component.css']
})
export class LovComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  lovDataTable: any;
  id: string; qid: string; colpos: string; wherecols: string; lovname: string;
  p1: string; p2: string; p3: string; p4: string;
  selectedData: any[] = [];
  rows: any;
  displayedColumns: string[];
  dataSource: any;
  selectedRowIndex = -1;
  constructor(private _service: LovService,
              private dialogRef: MatDialogRef<LovComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

    this.lovDataTable = data;

  }

  ngOnInit(): void {
    this.callLov();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onClick(): void {
    this.dialogRef.close(this.selectedData);
  }

  callLov() {
    this.id = this.lovDataTable[0];
    this.qid = this.lovDataTable[1]; 
    this.wherecols = this.lovDataTable[2];
    this.lovname = this.lovDataTable[3];

    var arr = this.wherecols.split(';');
    this.p1 = arr[0]; this.p2 = arr[1]; this.p3 = arr[2]; this.p4 = arr[3];

    this._service.getLov(this.qid, this.p1, this.p2, this.p3, this.p4).
      subscribe(res => {
        this.displayedColumns = Object.keys(res[0]);
        this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
        this.dataSource.paginator = this.paginator;
      }
     );
  }

  highlight(row) {
    this.selectedRowIndex = row;
    this.selectedData = row;
    
  }
}
